"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trainerStoreIsDown = trainerStoreIsDown;
const gateway_core_1 = require("@ifit/gateway-core");
async function trainerStoreIsDown(client = (0, gateway_core_1.getDefaultClient)()) {
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    return client.isDown('trainer-store');
}
//# sourceMappingURL=is-down.js.map